import { render, staticRenderFns } from "./PointRecordsTab.vue?vue&type=template&id=5db65b7c"
import script from "./PointRecordsTab.vue?vue&type=script&lang=js"
export * from "./PointRecordsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports